import { ImagePlus } from 'lucide-react'
import { useEffect, useRef } from 'react'

interface ImageContextMenuProps {
  x: number
  y: number
  onAddToTimeline: () => void
  onClose: () => void
}

export function ImageContextMenu({ x, y, onAddToTimeline, onClose }: ImageContextMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onClose()
      }
    }

    // Add listener after a small delay to prevent immediate close
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside as any)
    }, 100)

    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside as any)
    }
  }, [onClose])

  return (
    <div
      ref={menuRef}
      className="fixed z-[100] bg-card border border-border rounded-lg shadow-lg overflow-hidden min-w-[180px]"
      style={{
        left: `${x}px`,
        top: `${y}px`,
        transform: 'translateX(-50%)',
      }}
    >
      <button
        onClick={(e) => {
          e.stopPropagation()
          onAddToTimeline()
          onClose()
        }}
        className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted transition-colors text-left"
      >
        <ImagePlus className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-foreground">Add to Timeline</span>
      </button>
    </div>
  )
}


